require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-pav-bhaji-sandwich.json") })
        }
      }, "path---recipes-pav-bhaji-sandwich");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-pav-bhaji-sandwich!./.cache/json/recipes-pav-bhaji-sandwich.json
// module id = 736
// module chunks = 231608221292675